import { render, staticRenderFns } from "./PhysicalBilling.vue?vue&type=template&id=7a8d572e"
import script from "./PhysicalBilling.vue?vue&type=script&lang=js"
export * from "./PhysicalBilling.vue?vue&type=script&lang=js"
import style0 from "./PhysicalBilling.vue?vue&type=style&index=0&id=7a8d572e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a8d572e')) {
      api.createRecord('7a8d572e', component.options)
    } else {
      api.reload('7a8d572e', component.options)
    }
    module.hot.accept("./PhysicalBilling.vue?vue&type=template&id=7a8d572e", function () {
      api.rerender('7a8d572e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/settlement/PhysicalBilling.vue"
export default component.exports